import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog.jsx'
import { Input } from '@/components/ui/input.jsx'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import { updateCreatives } from '@/services/api.js'
import { useDashboardContext } from '@/context-state/DashboardContext.jsx'
import { CreativeVideoPreview } from '@/pages/dashboard/library/creative/CreativeVideoPreview.jsx'
import { CreativeProperties } from '@/pages/dashboard/library/creative/CreativeProperties.jsx'
import AnimatedTabs from '@/components/ui/AnimatedTabs.jsx'
import { CreativeActivityLog } from '@/pages/dashboard/library/creative/CreativeActivityLog.jsx'


const defaultImage = 'https://miro.com/app/images/application/icons/board_vis_230905/board_icon_22.png?etag=20230906'

export const CreativePreview = ({ onClose, creative, isOpen }) => {

    const [name, setName] = useState(creative.name)
    const { creativeContext } = useDashboardContext()
    const { updateCreativeStateById } = creativeContext
    const [chosenTab, setChosenTab] = useState({ id: "properties", title: "Properties" })

    const onCreativeUpdated = async (dataToUpdate) => {
        try {
            const { data } = await updateCreatives(creative._id, dataToUpdate)
            updateCreativeStateById(creative._id, data)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }

    useEffect(() => {
        if (name && name !== creative.name) {
            const handler = setTimeout(() => {
                onCreativeUpdated({ name })
            }, 800)
            return () => clearTimeout(handler)
        }
    }, [name])


    return (
        <Dialog open={isOpen} onOpenChange={onClose}>


            <DialogContent
                className="max-w-[1400px] w-[90%] h-[86vh]"
            >
                <DialogDescription className="hidden"/>
                <DialogHeader className="hidden">
                    <DialogTitle />
                </DialogHeader>

                <div className="flex w-full justify-between gap-4">


                    <div className="p-4 max-h-[75vh] w-[50%] max-w-[650px] overflow-hidden">
                        <div>
                            <Input
                                placeholder="Name"
                                value={name}
                                onChange={(e) => { setName(e.target.value) }}
                                className="bg-transparent text-md shadow-none truncate w-72 p-2"
                            />
                        </div>

                        <div className="bg-gray-200 p-4 rounded-lg relative h-full mt-2">
                            {
                                creative.type === 'video'
                                    ? <CreativeVideoPreview creative={creative}/>
                                    : <img src={creative.imageUrl ?? defaultImage} alt="" className="rounded-lg w-full h-full object-contain p-6"/>
                            }
                        </div>
                    </div>

                    <div className="p-2 flex-grow">

                        <AnimatedTabs
                            singleTabCssClass="flex-grow"
                            setActiveTab={setChosenTab}
                            activeTab={chosenTab}
                            tabs={[
                                { id: "properties", title: "Properties" },
                                { id: "activity", title: "Activity Log" },
                            ]}
                        />
                        <div className="py-4 px-2">

                            {
                                chosenTab.id === 'properties'
                                    ? <CreativeProperties
                                        onPropertyChanged={onCreativeUpdated}
                                        initialProperties={creative.properties}
                                    />
                                    : <CreativeActivityLog creative={creative} />
                            }

                        </div>




                        {/*    <div className="font-light underline">*/}
                        {/*        Activity Log*/}
                        {/*    </div>*/}
                        {/*    <div>*/}
                        {/*        <div className="text-sm font-light mt-2 flex gap-2 items-center">*/}
                        {/*            {*/}
                        {/*                creative.origin === 'Meta' && <Icon icon="logos:meta-icon"/>*/}
                        {/*            }*/}
                        {/*            {creative.origin === 'Meta' ? 'Synced from Meta on: ' : 'Created:'}*/}
                        {/*            {fDate(creative.createdAt)}*/}
                        {/*        </div>*/}
                        {/*    </div>*/}

                    </div>
                </div>


            </DialogContent>
        </Dialog>
    )
}